import axios from "axios";

const baseURL = process.env.REACT_APP_API_URL;

const LANGUAGE_STORAGE_KEY = "appLanguage"
const SUPPORTED_LANGUAGES = new Set(["az", "en", "ru"])

const normalizeLanguage = (value) => {
  if (!value) return "az"
  const normalized = String(value).toLowerCase().split("-")[0]
  return SUPPORTED_LANGUAGES.has(normalized) ? normalized : "az"
}

const getPreferredLanguage = () => {
  try {
    return normalizeLanguage(localStorage.getItem(LANGUAGE_STORAGE_KEY))
  } catch {
    return "az"
  }
}




const request = axios.create({
  baseURL: baseURL,
  withCredentials: false, 
  headers: {
    'Accept': 'application/json', 
    'Content-Type': 'application/json', 
  },
});

request.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    const language = getPreferredLanguage();
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    config.headers["Accept-Language"] = language;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

request.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const status = error.response?.status
    const url = error.config?.url || ""

    if (status === 401 && !url.includes("/api/auth/login")) {
      localStorage.removeItem("token")
      localStorage.removeItem("isLoggedIn")
      try {
        sessionStorage.removeItem("companyProfileCache")
      } catch {
        /* ignore */
      }
      window.dispatchEvent(new Event("auth:changed"))
    }

    return Promise.reject(error)
  }
);

export default request;



